import { Injectable } from '@angular/core'

type LogLevel = 'debug' | 'info' | 'warn' | 'error'

// Thin wrapper over console for centralized logging.
// Swap this implementation to send logs to a remote sink.
@Injectable({ providedIn: 'root' })
export class LoggerService {
  debug(message?: unknown, ...optionalParams: unknown[]) {
    this.log('debug', message, ...optionalParams)
  }
  info(message?: unknown, ...optionalParams: unknown[]) {
    this.log('info', message, ...optionalParams)
  }
  warn(message?: unknown, ...optionalParams: unknown[]) {
    this.log('warn', message, ...optionalParams)
  }
  error(message?: unknown, ...optionalParams: unknown[]) {
    this.log('error', message, ...optionalParams)
  }

  // future: send to remote logger (Sentry, Datadog) from here
  private log(_level: LogLevel, _message?: unknown, ..._optionalParams: unknown[]) {
    // eslint-disable-next-line no-console
    // console[level](`[${level.toUpperCase()}]`, message, ...optionalParams);
  }
}
